export const CARGO_SLICE_NAME = 'cargo';
